import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "@toddle-edu/ds-web";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import classes from "./ChatInfo.scss";
import {
  SUB_TEXT_LENGTH,
  SUB_TEXT_LENGTH_V2,
  isMessagingRevempEnabled,
} from "MessagingV2/modules/Utils";
import classNames from "classnames";
import StudentAlerts from "AppComponents/StudentAlerts";

const ChatInfo = props => {
  const {
    isMainTextHighlighted,
    mainText,
    subText,
    subTextComponent,
    bottomText,
    subTextClassName,
    userId,
    alertTypes,
  } = props;
  const isUIRevempEnabled = isMessagingRevempEnabled();

  const bottomTextClasses = classNames(classes.bottomText, "text-body-2");
  const subTextClasses = classNames(
    classes.subText,
    "text-body-2",
    subTextClassName
  );

  const subTextClassesV2 = classNames(
    classes.subTextV2,
    "text-body-3",
    subTextClassName
  );

  const mainTextClasses = classNames(classes.mainText, {
    "text-label-2": isMainTextHighlighted,
    "text-body-1": !isMainTextHighlighted,
  });

  const mainTextClassV2 = classNames(classes.mainTextV2, "text-body-2");

  const subTextLength = isUIRevempEnabled
    ? SUB_TEXT_LENGTH_V2
    : SUB_TEXT_LENGTH;

  return (
    <div className={classes.chatInfoContainer}>
      {mainText ? (
        <div className={classes.mainTextContainer}>
          <div
            className={isUIRevempEnabled ? mainTextClassV2 : mainTextClasses}
          >
            {mainText}
          </div>
          {userId && !_.isEmpty(alertTypes) ? (
            <StudentAlerts studentId={userId} alertTypes={alertTypes} />
          ) : null}
        </div>
      ) : null}

      {subTextComponent ? (
        subTextComponent
      ) : subText ? (
        <ConditionalWrapper
          wrapper={<Tooltip tooltip={subText} />}
          condition={_.size(subText) > subTextLength}
          type={"wrapperAsElement"}
        >
          <div
            className={isUIRevempEnabled ? subTextClassesV2 : subTextClasses}
          >
            {_.truncate(subText, { length: subTextLength })}
          </div>
        </ConditionalWrapper>
      ) : null}
      {bottomText ? (
        <div
          className={bottomTextClasses}
          dangerouslySetInnerHTML={{ __html: bottomText }}
        />
      ) : null}
    </div>
  );
};

ChatInfo.propTypes = {
  isMainTextHighlighted: PropTypes.bool,
  mainText: PropTypes.string,
  subText: PropTypes.string,
  bottomText: PropTypes.string,
  subTextClassName: PropTypes.string,
};

export default ChatInfo;
